export default __webpack_public_path__ + "static/red-2fbc136a42213b4f86f175c506c1e66b.png";